import React from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const HelpCard = ({ isCommercial, t }) => {
    const residentialCommercialVerbiage = isCommercial ?
        t("commercial_help_text"):
        t("residential_help_text")

    return (
        <React.Fragment>
            <div className="srp-card-header">
                {t("Need help?")}
            </div>

            <div className="srp-card-body ">
                <div className="srp-card-details srp-orange-background">
                    {residentialCommercialVerbiage}
                </div>
            </div>
        </React.Fragment>
    )
}

HelpCard.propTypes = {
    displaySpanish: PropTypes.bool,
    isCommercial: PropTypes.bool,
    t: PropTypes.func.isRequired,
    i18n: PropTypes.object.isRequired
}

export default withTranslation("startStopTransfer")(HelpCard)